const messages = {
  searchPlaceholder: {
    id: 'authoring.selectionmodal.search.placeholder',
    defaultMessage: 'Search',
    description: 'Placeholder text for search bar',
  },
  clearSearch: {
    id: 'authoring.selectionmodal.search.clearSearchButton',
    defaultMessage: 'Clear search query',
    description: 'Button to clear search query',
  },
  emptySearchLabel: {
    id: 'authoring.selectionmodal.emptySearchLabel',
    defaultMessage: 'No search results.',
    description: 'Label for when search returns nothing.',
  },
  loading: {
    id: 'authoring.selectionmodal.spinner.readertext',
    defaultMessage: 'loading...',
    description: 'Gallery loading spinner screen-reader text',
  },
  addedDate: {
    id: 'authoring.selectionmodal.addedDate.label',
    defaultMessage: 'Added {date} at {time}',
    description: 'File date-added string',
  },
  sortBy: {
    id: 'authoring.selectionmodal.sortBy',
    defaultMessage: 'By',
    description: '"By" before sort option',
  },
};

export default messages;
